import React from 'react';

export default function SelectBox(props) {
  const { name, options, value, label, isRequired } = props;

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    props.onChange(selectedValue);
  };

  return (
    <div className="col-md-6 text-left">
      <label className="custom-label">
        {label} {isRequired && <span className="astric">*</span>}
      </label>
      <select
        name={name}
        className="form-input"
        value={value}
        onChange={handleChange}
      >
        {options.map((data) => (
          <option key={data.value} value={data.value}>
            {data.label}
          </option>
        ))}
      </select>
    </div>
  );
}